import app from './app'
import { unbindEvents } from './dom-event-pool'
import emitter from './event'
import globalContext, { resetGlobalContext } from './global-context'

class Api {
  constructor() {}

  selectBrush() {
    globalContext.tool.name = 'brush'
  }

  selectErase() {
    globalContext.tool.name = 'erase'
  }

  selectSelect() {
    globalContext.tool.name = 'select'
  }

  setLineWidth(lineWidth: number) {
    globalContext.lineWidth = lineWidth
  }

  zoomAtCenter(n: number) {
    app.gui?.centerZoom(n)
  }

  loadBottomImage(url: string) {
    resetGlobalContext()
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.onload = () => {
      globalContext.bottomImage = img
      globalContext.needRender = true
    }
    img.src = url
  }

  saveMask() {
    return app.layersManager?.saveMask()
  }

  back() {
    app.state?.undoAction()
  }

  reset() {
    const bottomImage = globalContext.bottomImage
    resetGlobalContext()
    globalContext.bottomImage = bottomImage
    globalContext.needRender = true
  }

  onZoom(handler: (zoom: number) => void) {
    emitter.on('zoom', handler as any)
  }

  destroy() {
    resetGlobalContext()
    emitter.off('zoom')
    app.layersManager?.destroy()
    unbindEvents()
  }
}

export default Api
